import type { NavigateFunction } from "react-router-dom";

import type { InboundReceiveArrivalPackageNav } from "./inboundReceiveNavigation";
import {
  buildInboundReceiveNavigateTarget,
  mergeInboundReceiveArrivalPackageSearch,
} from "./inboundReceiveNavigation";
import {
  inboundReceiveRouteUsesSpecialDesk,
  type InboundReceiveRoute,
} from "./inboundReceiveRoute";

export function buildInboundSpecialReceiveDeskPath(route: InboundReceiveRoute): string {
  if (route === "rma") return "/shipping/receive/rma";
  if (route === "non_po_purchase") return "/shipping/receive/non-po-purchase";
  throw new Error("Not a special receive desk route.");
}

export function navigateAfterInboundReceiveRouteApplied(
  navigate: NavigateFunction,
  input: {
    receive_route: InboundReceiveRoute;
    resolved_source: {
      source_type: string;
      source_id: string;
    } | null;
    package_id: string;
    package_no: number;
    arrival_id?: string;
    rma_number?: string | null;
    rma_count_checked?: boolean;
    scan: string;
    unitKind: string;
  },
): void {
  const crate: InboundReceiveArrivalPackageNav = {
    arrivalPackageId: input.package_id,
    arrivalPackageNo: input.package_no,
    arrivalId: input.arrival_id,
    arrivalScan: input.scan,
    arrivalUnitKind: input.unitKind as InboundReceiveArrivalPackageNav["arrivalUnitKind"],
    rmaNumber: input.rma_number ?? null,
    rmaCountChecked: input.rma_count_checked === true,
  };
  if (inboundReceiveRouteUsesSpecialDesk(input.receive_route)) {
    const path = buildInboundSpecialReceiveDeskPath(input.receive_route);
    const search = mergeInboundReceiveArrivalPackageSearch(new URLSearchParams(), crate).toString();
    navigate({ pathname: path, search }, { state: crate });
    return;
  }
  if (input.resolved_source == null) {
    return;
  }
  const target = buildInboundReceiveNavigateTarget(
    input.resolved_source.source_type,
    input.resolved_source.source_id,
    crate,
  );
  navigate({ pathname: target.pathname, search: target.search }, { state: target.state });
}
